
import React from 'react';
import './founder.css';
import founderImage from './images/Owano.jpg';

const Founder = () => {
  return (
    <div className="founder-container">
      <div className="founder-image-container">
        <img src={founderImage} alt="Franz Owano" className="founder-image" />
      </div>
      <div className="founder-info">
        <h2>About the Founder</h2>
        <p>
          <strong>Franz Owano</strong> (Medical Doctor, Author, Publisher) began writing seriously over a decade ago while still a medical student at the University of Nairobi. Seeking a creative outlet from the demands of his profession, he ventured into literature, transforming his experiences with the human condition as a medical practitioner into compelling literary works.
        </p>
        <p>
          His published works include five plays, four short story collections, an anthology of poems, a novella, and several novels, spanning genres from contemporary fiction, African folklore, and religious fantasy to historical and science fiction. A testament to the quality of his work the following notable titles penned by Dr. Owano have been purchased and archived in the United States Library Of Congress:-
        </p>
        <ul>
          <li><strong>The Chief Must Die</strong> (2021): A collection of essays and short stories.</li>
          <li><strong>The Heart of a Prince</strong> (2022): A historical fiction novel.</li>
          <li><strong>Simbi</strong> (2023): A collaborative anthology of essays and short stories.</li>
          <li><strong>Simians</strong> (2023): A novella by George Gathiani, published under Wanderer’s Path Publishers.</li>
          <li><strong>Visions of Chrysalis</strong> (2024): An afro-futurist science fiction novel.</li>

	  <li><strong>Trails of Chepondor</strong> (2024): A play</li>
	   <li><strong>Fall of Kings</strong> (2024):  A historical fiction novel</li>
	<li><strong>Boy Child</strong> (2025): A coming of age novel</li>


        </ul>
        <p>
          Franz founded <strong>Wanderer’s Path Publishers</strong> to support creative voices in Kenya, encouraging writers to express themselves freely outside the confines of traditional publishing. Additionally, he established the <strong>Pan African Book Exchange</strong>, a dynamic online ebook market, to foster collective knowledge and literary engagement across the continent.
        </p>
      </div>
    </div>
  );
};

export default Founder;
